// urlText.js

export default function urlText(text) {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/gi, '-') // replace non-alphanumerics with "-"
    .replace(/^-+|-+$/g, '');     // trim leading/trailing hyphens
}
